// @ts-expect-error: @rails/request.js is not typed
import { FetchRequest } from '@rails/request.js'
import { useMutation } from '@tanstack/react-query'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'
import { type Quote } from '../prospects/types'

type QuotePatchParam = {
  censusId: string;
}

export function useModifyQuote ({
  prospectId,
  quoteId,
}: {
  prospectId: string;
  quoteId: string;
}) {
  return useMutation<Quote, GrapeAPIErrorType, QuotePatchParam>({
    mutationFn: async ({ censusId }) => {
      const request = new FetchRequest(
        'patch',
        `/api/web/quoting/prospects/${prospectId}/quotes/${quoteId}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: {
            quoting_prospect_employee_census_id: censusId,
          },
        }
      )
      const response = await request.perform()
      if (!response.ok) {
        const errors = await response.json
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
        })
      }
      return response.json
    },
  })
}
